import React from "react";

import {
  MDBCarousel,
  MDBCarouselCaption,
  MDBCarouselInner,
  MDBCarouselItem,
} from "mdbreact";

import "./Hero.css";

export default () => {
  return (
    <div className="carousel">
      <MDBCarousel
        activeItem={1}
        length={1}
        showControls={false}
        showIndicators={false}
        className="z-depth-1"
      >
        <MDBCarouselInner>
          <MDBCarouselItem itemId={1} id="img-1">
            <MDBCarouselCaption>
              <h1>
                Somos o Centro de Pesquisa e Reabilitação Visual de Itapetininga
              </h1>
              <h3>Centro de tratamento</h3>
            </MDBCarouselCaption>
          </MDBCarouselItem>
        </MDBCarouselInner>
      </MDBCarousel>
    </div>
  );
};
